import React from 'react';
import { useNFe } from '../../../../hooks/useNFe';
import NFeStatusBadge from '../../components/NFeStatusBadge';
import { formatDateBrazil } from '../../../../utils/dateUtils';
import '../../nfe.css';

interface CabecalhoNFeProps {
  nfeId: string;
}

const formatarMoeda = (v: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);

const CabecalhoNFe: React.FC<CabecalhoNFeProps> = ({ nfeId }) => {
  const { data: nfe } = useNFe(nfeId);

  return (
    <div className="nfe-doc-header mb-3">
      <div className="nfe-doc-header__bg-text">NF-e</div>

      <div className="d-flex align-items-center flex-wrap gap-3">
        {/* Number + status */}
        <div className="flex-grow-1">
          <div className="nfe-doc-header__kicker">Nota Fiscal Eletrônica</div>
          <div className="nfe-doc-header__number">
            #{String(nfe?.numero ?? 0).padStart(9, '0')}
          </div>
          <div className="nfe-doc-header__meta">
            Série {nfe?.serie} &nbsp;·&nbsp; {formatDateBrazil(nfe?.dataEmissao)}
          </div>
        </div>

        {/* Divider */}
        <div className="nfe-doc-header__divider d-none d-md-block" />

        {/* Emitente */}
        <div>
          <div className="nfe-doc-header__field-label">Emitente</div>
          <div className="nfe-doc-header__field-value">
            {nfe?.emitente?.nomeFantasia ?? nfe?.emitente?.nomeRazaoSocial ?? nfe?.empresaNome}
          </div>
        </div>

        {/* Divider */}
        <div className="nfe-doc-header__divider d-none d-lg-block" />

        {/* Valor + status */}
        <div className="text-end">
          <div className="nfe-doc-header__field-label">Valor Total</div>
          <div className="nfe-doc-header__amount">{formatarMoeda(nfe?.totais?.valorNota ?? 0)}</div>
          <div className="mt-1">
            <NFeStatusBadge status={nfe?.status} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CabecalhoNFe;
